import React from 'react';

const TermsAndConditionsPage = () => {
    const QnA = {

  "Overview":
    "This website is operated by The Average Collector Pty Ltd. Throughout the site, the terms “we”, “us”, and “our” refer to The Average Collector Pty Ltd. We offer this website, including all information, tools, and services available from this site, conditioned upon your acceptance of all terms, conditions, policies, and notices stated here.",

  "Acceptance of Terms":
    "By accessing our site and/or purchasing products or services from us, you engage in our services and agree to be bound by these Terms and Conditions, including any additional terms, policies, or notices referenced herein. These Terms apply to all users of the site, including browsers, customers, vendors, merchants, and contributors of content. If you do not agree to all terms, you may not access or use the site.",

  "Changes to Terms":
    "We reserve the right to update, modify, or replace any part of these Terms at any time by posting changes to our website. It is your responsibility to review this page periodically. Continued use of the site following any changes constitutes acceptance of the updated Terms.",

  "Fair Use and Purchase Limits":
    "We reserve the right to refuse or cancel orders that, in our sole discretion, appear to be placed for the purpose of resale, bulk buyouts, product flipping, or otherwise undermining fair access for the community. Orders identified as such may be cancelled and refunded without further communication.",

  "Online Store Eligibility":
    "By agreeing to these Terms, you confirm that you are at least the age of majority in your jurisdiction or have obtained appropriate consent. You may not use our products or services for any unlawful or unauthorised purpose, nor violate any applicable laws, including intellectual property laws.",

  "Abandoned Orders and Forfeiture":
    "If a customer has placed an order and has not paid the applicable shipping fees, and has not made any form of communication with us regarding the order for a period of six (6) months from the date of order confirmation or last correspondence (whichever is later), the order will be deemed abandoned. Upon being deemed abandoned, we reserve the right to forfeit, dispose of, or otherwise handle the goods at our sole discretion without any obligation to provide a refund or compensation to the customer.",
    
  "General Conditions":
    "We reserve the right to refuse service to anyone for any reason at any time. Content submitted by users (excluding payment information) may be transferred unencrypted across various networks to conform with technical requirements. Payment information is always encrypted during transmission.",

  "Intellectual Property":
    "All content on this website, including branding, logos, text, images, graphics, and designs, is owned by or licensed to us. You may not reproduce, duplicate, copy, sell, resell, or exploit any part of the service without express written permission.",

  "Accuracy of Information":
    "We are not responsible if information on this site is inaccurate, incomplete, or outdated. Information is provided for general purposes only and should not be relied upon as the sole basis for decision-making. Reliance on site content is at your own risk.",

  "Service and Price Modifications":
    "Prices and services are subject to change without notice. We reserve the right to modify or discontinue the service (or any part thereof) at any time without notice and shall not be liable for any such changes.",

  "Products and Availability":
    "Certain products may be available exclusively online and in limited quantities. We reserve the right to limit sales by person, household, region, or jurisdiction. All product descriptions and pricing are subject to change at our sole discretion. We do not warrant that products or services will meet expectations.",

  "Billing and Account Information":
    "We reserve the right to refuse or cancel any order. Restrictions may apply to orders using the same account, payment method, or address. You agree to provide current, complete, and accurate account and purchase information and to keep it updated.",

  "Third-Party Tools":
    "We may provide access to third-party tools over which we have no control. Such tools are provided “as is” without warranties or conditions. Use of third-party tools is entirely at your own risk.",

  "Third-Party Links":
    "Our service may include materials or links to third-party websites. We are not responsible for the content, accuracy, or practices of third-party sites, and any interactions with them are at your own risk.",

  "User Submissions":
    "Any comments, feedback, or materials you submit may be used by us without restriction. We are under no obligation to maintain submissions in confidence or provide compensation. We reserve the right to remove content deemed unlawful, offensive, or in breach of these Terms.",

  "Personal Information":
    "Your submission of personal information through the site is governed by our Privacy Policy.",

  "Errors and Omissions":
    "We reserve the right to correct errors, inaccuracies, or omissions and to cancel orders if information on the site is inaccurate, even after an order has been submitted.",

  "Prohibited Uses":
    "You may not use this site for unlawful purposes, harassment, discrimination, misinformation, intellectual property violations, malicious activities, or security circumvention. Violations may result in termination of access.",

  "Disclaimer of Warranties":
    "The service and all products are provided “as is” and “as available” without warranties of any kind, express or implied, including merchantability, fitness for purpose, and non-infringement, except where required by law.",

  "Limitation of Liability":
    "To the maximum extent permitted by law, we are not liable for any indirect, incidental, special, or consequential damages arising from use of the service or products. Where liability cannot be excluded, it is limited to the maximum extent permitted under Australian Consumer Law.",

  "Indemnification":
    "You agree to indemnify and hold harmless The Average Collector Pty Ltd and its affiliates from any claim or demand arising from your breach of these Terms or violation of any law or third-party rights.",

  "Severability":
    "If any provision of these Terms is found to be unlawful or unenforceable, the remaining provisions remain in full force and effect.",

  "Termination":
    "These Terms remain effective unless terminated by you or us. We may terminate or suspend access without notice if we suspect a breach of these Terms. Obligations incurred prior to termination survive termination.",

  "Entire Agreement":
    "These Terms, together with any policies posted on this site, constitute the entire agreement between you and us and supersede any prior communications or agreements.",

  "Governing Law":
    "These Terms are governed by and construed in accordance with the laws of Australia.",

  "Contact Information":
    "If you have any questions regarding these Terms, please contact us at avgpokecollector@gmail.com."
};



  return (
    <div className='qna hide-scrollbar'>
      {Object.entries(QnA).map(([question, answer], index) => (
        <div key={index} className='bottom-margin'>
          <h1 className='question no-margin'>{question}</h1>
          <div className='answer no-margin'>{answer}</div>
        </div>
      ))}
    </div>
  );
};

export default TermsAndConditionsPage;
